import type { FeedStatus } from '@clutch/core';

/** Beyond this, the room says DELAYED rather than LIVE: the fan is watching the past. */
export const DELAYED_AFTER_MS = 60_000;

/**
 * "LIVE · ESPN feed · 3s lag" / "DELAYED · ESPN feed · 2m behind" / retrying — exactly where the
 * data comes from and how fresh it is. Replays return undefined (the stage shows REPLAY).
 */
export function feedBadge(feed: FeedStatus | undefined): { text: string; live: boolean; state: 'live' | 'delayed' | 'retrying'; title?: string } | undefined {
  if (!feed || feed.mode !== 'live') return undefined;
  const src = feed.source === 'espn_public' ? 'ESPN feed' : 'live feed';
  const title = feed.message ? { title: feed.message } : {};
  if (!feed.healthy) return { text: `LIVE · ${src} · retrying`, live: true, state: 'retrying', ...title };
  const lagMs = typeof feed.lagMs === 'number' && Number.isFinite(feed.lagMs) ? feed.lagMs : undefined;
  if (lagMs !== undefined && lagMs > DELAYED_AFTER_MS) {
    const behind = lagMs >= 3_600_000 ? `${Math.round(lagMs / 3_600_000)}h` : `${Math.round(lagMs / 60_000)}m`;
    return { text: `DELAYED · ${src} · ${behind} behind`, live: false, state: 'delayed', ...title };
  }
  const lag = lagMs !== undefined ? ` · ${Math.max(1, Math.round(lagMs / 1000))}s lag` : '';
  return { text: `LIVE · ${src}${lag}`, live: true, state: 'live', ...title };
}
